<template>
  <v-app-bar height="56" fixed light app>
    <!-- input - search -->
    <div v-if="isSearch" class="header-wrapper">
      <v-text-field
        v-model="searchBar"
        class="no-label color-accent search-claim-field"
        :placeholder="searchBarPlaceholder"
        persistent-placeholder
        :prepend-inner-icon="mdiMagnify"
        @keyup.enter.native="searchTriggered"
      ></v-text-field>

      <v-btn text color="var(--bg)" @click="searchButtonHandler">Cancel</v-btn>
    </div>

    <div v-else class="header-wrapper">
      <!-- icon left - logo company -->
      <div v-if="headerIconLeft.type === 'icon'" class="logo-wrapper">
        <a href="/home">
          <img :src="userOrganisationLogo" alt="Dashboard" />
        </a>
      </div>

      <!-- icon left - button back -->
      <div v-else-if="headerIconLeft.type === 'back'">
        <nuxt-link :to="getBackLink">
          <v-icon color="var(--bg)" size="34" @click="closeCamera">
            {{ mdiChevronLeft }}
          </v-icon>
        </nuxt-link>
      </div>

      <!-- icon left - empty -->
      <div v-else class="hidden">
        <v-icon color="transparent">{{ mdiMagnify }}</v-icon>
      </div>

      <!-- page title -->
      <div class="page-title">
        {{
          $helpers.translateKeyContent(
            "QoalaExternalDashboardGadget",
            pageInfo.pageTitle,
          )
        }}
      </div>

      <!-- icon right - notification -->
      <v-menu
        v-if="headerIconRight.type === 'notification'"
        :nudge-bottom="14"
        attach
        left
        offset-y
      >
        <template #activator="{ on }">
          <v-icon color="var(--bg)" v-on="on">
            <!-- notifications -->
            {{ mdiBell }}
          </v-icon>
          <!-- <v-btn
            icon
            text
            v-on="on"
          >
            <v-badge
              color="red"
              overlap
            >
              <span slot="badge">
                3
              </span>
              <v-icon medium>
                notifications
              </v-icon>
            </v-badge>
          </v-btn> -->
        </template>
      </v-menu>

      <div
        v-else-if="headerIconRight.type === 'search' && getModule !== 'gadget'"
      >
        <v-icon color="var(--bg)" @click="searchButtonHandler">
          {{ mdiMagnify }}
        </v-icon>
      </div>

      <!-- icon right - share -->
      <div v-else-if="headerIconRight.type === 'share'">
        <v-icon color="var(--bg)" medium @click="headerIconRight.action">
          {{ mdiShareVariant }}
        </v-icon>
      </div>

      <!-- icon right - empty -->
      <div v-else class="hidden">
        <v-icon color="transparent">{{ mdiMagnify }}</v-icon>
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import { mdiMagnify, mdiChevronLeft, mdiBell, mdiShareVariant } from "@mdi/js";
import { get } from "lodash-es";

export default {
  name: "MobileAppHeader",
  data() {
    return {
      mdiMagnify,
      mdiChevronLeft,
      mdiBell,
      mdiShareVariant,
    };
  },
  computed: {
    pageInfo() {
      return get(this.$store, 'getters["app/getPageInfo"]', {});
    },

    headerIconLeft() {
      return get(this.$store, 'getters["mobile/getHeaderIconLeft"]', {});
    },

    headerIconRight() {
      return get(this.$store, 'getters["mobile/getHeaderIconRight"]', {});
    },

    searchBar: {
      get() {
        return this.$store.getters["mobile/getSearchBar"];
      },
      set(value) {
        this.$store.dispatch("mobile/setSearchBar", value);
      },
    },

    getBackLink() {
      return this.$store.getters["mobile/getBackLink"];
    },

    searchBarPlaceholder() {
      return get(
        this.$store,
        'getters["mobile/getSearchBarPlaceholder"]',
        "Search",
      );
    },

    isSearch: {
      get() {
        return this.$store.getters["mobile/getSearchBarCondition"];
      },
      set(value) {
        this.$store.dispatch("mobile/setSearchBarCondition", value);
      },
    },
  },

  methods: {
    closeCamera() {
      if (this.headerIconLeft.action) this.headerIconLeft.action.reset();
    },

    searchButtonHandler() {
      this.$store.dispatch("mobile/setSearchBarCondition", !this.isSearch);

      // search is closed && search bar not empty
      if (!this.isSearch && this.$store.getters["mobile/getSearchBar"] !== "") {
        this.$store.dispatch("mobile/setSearchBar", "");
        // call triggered (make search bar entered)
        this.searchTriggered();
      }
    },

    backHandler() {
      if (this.getBackLink) this.$router.push(this.getBackLink);
    },

    searchTriggered() {
      // turn on triggered
      this.$store.dispatch("mobile/setSearchBarTriggered", true);

      // turn off triggered
      setTimeout(() => {
        this.$store.dispatch("mobile/setSearchBarTriggered", false);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-toolbar {
  box-shadow: none;

  .v-toolbar__content {
    padding: 4px 12px;
    /* padding: 12px; */
    box-shadow: 0 0 8px rgb(var(--shadow-rgb), 0.5);

    .header-wrapper {
      height: inherit;
      margin: 0 auto;
      display: flex;
      align-items: center;
      width: $tabWidth;
      padding: 0 12px;

      @media (max-width: $tabWidth) {
        width: 100%;
        padding: 0;
      }

      .v-text-field {
        margin: 0px;

        &::before {
          border: 0.5em;
          height: 100%;
          background-color: $formBackground;
        }

        .v-input__control {
          .v-input__slot {
            height: 35px;
            padding: 0px 5px;

            ::placeholder {
              color: $textColor !important;
            }

            .v-input__prepend-inner {
              margin: auto 0px;

              .mdi-magnify {
                color: $textColor;

                &.primary--text {
                  color: $textColor !important;
                }
              }
            }
          }

          .v-text-field__details {
            display: none;
          }
        }
      }

      .v-btn {
        padding: 0px 0px 0px 5px;
      }
    }

    a {
      &:hover {
        text-decoration: none !important;
      }
    }
  }

  &.theme--light.v-app-bar.v-sheet {
    background-color: #fff;
  }
}

.page-title {
  flex: 1;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: var(--bg);
}

.logo-wrapper {
  a {
    display: block;
    height: 24px;

    img {
      height: 100%;
    }
  }
}

.hidden {
  visibility: hidden;
}
</style>
